module.exports = __webpack_public_path__ + "img/transfer.52470529.png";